import { FunctionDialog } from "@/components/FunctionsModal";
import {
  ChatFunctionCall,
  Function_,
  FunctionsType,
  Tool,
  ToolChoice,
} from "@/types";
import { usePlayground } from "@/components/Playground2/playground-store";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";

const Functions = observer(({ readonly = false }: { readonly?: boolean }) => {
  const playground = usePlayground();
  if (playground.mode === "completion") return null;

  const functionsType = playground.functionType;

  const functions = toJS(
    (functionsType === "tools" ? playground.tools : playground.functions) ?? [],
  );

  const functionCall = playground.functionCall ?? undefined;
  const toolChoice = playground.toolChoice ?? undefined;

  const setFunctionsType = (newFunctionsType: FunctionsType) => {
    if (newFunctionsType === "tools") {
      const tools = functions.map((func: Function_) => ({
        type: "function" as const,
        function: func,
      }));
      playground.updateTools(tools);
      if (functionCall) {
        playground.updateToolChoice(
          typeof functionCall === "string"
            ? functionCall
            : {
                type: "function",
                function: functionCall,
              },
        );
      }
      playground.updateFunctions(undefined);
      playground.updateFunctionCall(undefined);
    } else {
      playground.updateFunctions(functions);
      if (toolChoice) {
        playground.updateFunctionCall(
          typeof toolChoice === "string"
            ? toolChoice
            : {
                name: toolChoice.function.name,
              },
        );
      }
      playground.updateTools(undefined);
      playground.updateToolChoice(undefined);
    }
  };

  const setFunctions = (newFunctions: Array<Function_>) => {
    if (functionsType === "tools") {
      const tools = newFunctions.map<Tool>((func) => ({
        type: "function",
        function: func,
      }));
      playground.updateTools(tools);
    } else {
      playground.updateFunctions(newFunctions);
    }
  };

  const onSubmit = (newFunction: any) => {
    let prev = JSON.parse(JSON.stringify(functions));
    const index = prev.findIndex(
      (func: Function_) => func.name === newFunction.name,
    );
    if (index !== -1) {
      prev[index] = newFunction;
    } else {
      prev = prev.concat([newFunction]);
    }

    setFunctions(prev);
  };

  const setFunctionCall = (newFunctionCall: ChatFunctionCall) => {
    if (functionsType === "tools") {
      const tool_choice: ToolChoice =
        typeof newFunctionCall === "string"
          ? newFunctionCall
          : {
              type: "function",
              function: newFunctionCall,
            };
      playground.updateToolChoice(tool_choice);
    } else {
      playground.updateFunctionCall(newFunctionCall);
    }
  };

  return (
    <FunctionDialog
      functions={functions}
      functionCall={functionCall}
      toolChoice={functionsType === "tools" ? toolChoice : undefined}
      functionsType={functionsType}
      onSubmit={onSubmit}
      setFunctionCall={setFunctionCall}
      setFunctions={setFunctions}
      setFunctionsType={setFunctionsType}
      readonly={readonly}
    />
  );
});

export default Functions;
